import store from '@/store'
import { MUTATIONS } from '@/store/mutations'

import AppEvents from '@/plugins/EventBus/events'
import AppEventBus from '@/plugins/EventBus/event-bus'

import ProgressManager from '@/progress-manager'

// noinspection JSValidateJSDoc
const Events = {

    /**
     * Router event.
     * @param {Route} to
     * @param {Route} from
     * @returns {Promise<void>}
     */
    afterEach: function(to, from) {
        store.commit(MUTATIONS.ROUTES.storeRoutes, { current: to, last: from })

        if (to.name !== 'MyHome')
            store.commit(MUTATIONS.clearAllErrors)
        else
            store.commit(MUTATIONS.clearOldErrors)

        ProgressManager.markVisitedRoute(to.name)
    },

    /**
     * Router event.
     * @param {Route} to
     * @param {Route} from
     * @param {Function} next
     */
    beforeResolve: function(to, from, next) {

        if (from && from.name && from.name.includes('MyHomeEdit')) {
            AppEventBus.$emit(AppEvents.hideMask)
            AppEventBus.$emit(AppEvents.infoAttachmentShown, false)
        }

        next()
    },
}

export default Events
